
// スマホでのサードメニュー位置調整
if( $.isMobile && $('.js-move-thirdmenu').length ){
    var active_third = $('.js-move-thirdmenu > li[data-menu-active="true"] .c-thirdmenu');
    if( active_third.length ){
        // サードメニューを移動させる
        $('.js-move-thirdmenu').after( active_third );
    }
}



//////////////////
// WEBPACK FOOTER
// ./js/module/submenu.js
// module id = 10
// module chunks = 0